import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';
import { BrowserRouter, Route } from 'react-router-dom';

import QueueStats from "../react/admin/QueueStats";
import LazyLoader from "../imports/LazyLoader.js";

$(function() {

	let graphsPage = $('#the_graphs');
	if(!graphsPage.length) {
		return;
	}

	if(graphsPage.hasClass('socket_summary')) {
		LazyLoader.socketMonitor()
			.then((SocketMonitor) => {
				renderIntoContainer(
					<SocketMonitor
					/>,
					graphsPage[0]
				);
			});

		return;
	}

	if(graphsPage.hasClass('login_methods')) {
		LazyLoader.loginMethods()
			.then((LoginMethods) => {
				renderIntoContainer(<LoginMethods />, graphsPage[0]);
			});

		return;
	}

	if(graphsPage.hasClass('queue_stats')) {
		renderIntoContainer(
			<QueueStats
			/>,
			graphsPage[0]
		);
		return;
	}

	if(graphsPage.hasClass('user_graphs')) {
		const basename = '/graphs';
		const baseUrl = `${siteUrl}${basename}`;
		LazyLoader.userGraphs()
			.then(({ default: UserGraphs }) => {
				renderIntoContainer(
					<BrowserRouter basename={basename}>
						<Route
							render={(props) => (
								<UserGraphs
									{...props}
								/>
							)}
						/>
					</BrowserRouter>, graphsPage[0]
				);
			});
	}

	if(graphsPage.hasClass('subscription_graphs')) {
		const basename = '/graphs';
		LazyLoader.subscriptionGraphs()
			.then(({ default: SubscriptionGraphs }) => {
				renderIntoContainer(
					<BrowserRouter basename={basename}>
						<Route
							render={(props) => (
								<SubscriptionGraphs
									{...props}
								/>
							)}
						/>
					</BrowserRouter>, graphsPage[0]
				);
			});
	}

});